export default function copyToClipboard(value, doc = document) {
  const input = doc.createElement('textarea');
  doc.body.appendChild(input);
  input.value = value;
  input.select();
  const copyRes = doc.execCommand('copy');
  doc.body.removeChild(input);
  return copyRes;
}
//# sourceMappingURL=clipboard.js.map
